// Sports Wordle Player Database
import type { Player } from "./sports-wordle-data"

// NBA Players with complete data
export const nbaPlayers: Player[] = [
  // Current Stars - Lakers
  {
    id: "lebron",
    firstName: "LeBron",
    lastName: "James",
    fullName: "LeBron James",
    sport: "basketball",
    league: "NBA",
    team: "Lakers",
    position: "F",
    jerseyNumber: 23,
    yearsActive: "2003-present",
    yearStart: 2003,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'9\"",
    conference: "West",
  },
  {
    id: "davis",
    firstName: "Anthony",
    lastName: "Davis",
    fullName: "Anthony Davis",
    sport: "basketball",
    league: "NBA",
    team: "Lakers",
    position: "F",
    jerseyNumber: 3,
    yearsActive: "2012-present",
    yearStart: 2012,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'10\"",
    conference: "West",
  },

  // Warriors
  {
    id: "curry",
    firstName: "Stephen",
    lastName: "Curry",
    fullName: "Stephen Curry",
    sport: "basketball",
    league: "NBA",
    team: "Warriors",
    position: "G",
    jerseyNumber: 30,
    yearsActive: "2009-present",
    yearStart: 2009,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'2\"",
    conference: "West",
  },
  {
    id: "thompson",
    firstName: "Klay",
    lastName: "Thompson",
    fullName: "Klay Thompson",
    sport: "basketball",
    league: "NBA",
    team: "Warriors",
    position: "G",
    jerseyNumber: 11,
    yearsActive: "2011-present",
    yearStart: 2011,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'6\"",
    conference: "West",
  },
  {
    id: "green",
    firstName: "Draymond",
    lastName: "Green",
    fullName: "Draymond Green",
    sport: "basketball",
    league: "NBA",
    team: "Warriors",
    position: "F",
    jerseyNumber: 23,
    yearsActive: "2012-present",
    yearStart: 2012,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'6\"",
    conference: "West",
  },

  // Bucks
  {
    id: "giannis",
    firstName: "Giannis",
    lastName: "Antetokounmpo",
    fullName: "Giannis Antetokounmpo",
    sport: "basketball",
    league: "NBA",
    team: "Bucks",
    position: "F",
    jerseyNumber: 34,
    yearsActive: "2013-present",
    yearStart: 2013,
    yearEnd: null,
    country: "Greece",
    isRetired: false,
    height: "6'11\"",
    conference: "East",
  },
  {
    id: "lillard",
    firstName: "Damian",
    lastName: "Lillard",
    fullName: "Damian Lillard",
    sport: "basketball",
    league: "NBA",
    team: "Bucks",
    position: "G",
    jerseyNumber: 0,
    yearsActive: "2012-present",
    yearStart: 2012,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'2\"",
    conference: "East",
  },

  // Suns
  {
    id: "durant",
    firstName: "Kevin",
    lastName: "Durant",
    fullName: "Kevin Durant",
    sport: "basketball",
    league: "NBA",
    team: "Suns",
    position: "F",
    jerseyNumber: 35,
    yearsActive: "2007-present",
    yearStart: 2007,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'10\"",
    conference: "West",
  },
  {
    id: "booker",
    firstName: "Devin",
    lastName: "Booker",
    fullName: "Devin Booker",
    sport: "basketball",
    league: "NBA",
    team: "Suns",
    position: "G",
    jerseyNumber: 1,
    yearsActive: "2015-present",
    yearStart: 2015,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'5\"",
    conference: "West",
  },

  // Nuggets
  {
    id: "jokic",
    firstName: "Nikola",
    lastName: "Jokic",
    fullName: "Nikola Jokic",
    sport: "basketball",
    league: "NBA",
    team: "Nuggets",
    position: "C",
    jerseyNumber: 15,
    yearsActive: "2015-present",
    yearStart: 2015,
    yearEnd: null,
    country: "Serbia",
    isRetired: false,
    height: "6'11\"",
    conference: "West",
  },
  {
    id: "murray",
    firstName: "Jamal",
    lastName: "Murray",
    fullName: "Jamal Murray",
    sport: "basketball",
    league: "NBA",
    team: "Nuggets",
    position: "G",
    jerseyNumber: 27,
    yearsActive: "2016-present",
    yearStart: 2016,
    yearEnd: null,
    country: "Canada",
    isRetired: false,
    height: "6'4\"",
    conference: "West",
  },

  // Mavericks
  {
    id: "luka",
    firstName: "Luka",
    lastName: "Doncic",
    fullName: "Luka Doncic",
    sport: "basketball",
    league: "NBA",
    team: "Mavericks",
    position: "G",
    jerseyNumber: 77,
    yearsActive: "2018-present",
    yearStart: 2018,
    yearEnd: null,
    country: "Slovenia",
    isRetired: false,
    height: "6'7\"",
    conference: "West",
  },
  {
    id: "irving",
    firstName: "Kyrie",
    lastName: "Irving",
    fullName: "Kyrie Irving",
    sport: "basketball",
    league: "NBA",
    team: "Mavericks",
    position: "G",
    jerseyNumber: 11,
    yearsActive: "2011-present",
    yearStart: 2011,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'2\"",
    conference: "West",
  },

  // Celtics
  {
    id: "tatum",
    firstName: "Jayson",
    lastName: "Tatum",
    fullName: "Jayson Tatum",
    sport: "basketball",
    league: "NBA",
    team: "Celtics",
    position: "F",
    jerseyNumber: 0,
    yearsActive: "2017-present",
    yearStart: 2017,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'8\"",
    conference: "East",
  },
  {
    id: "brown",
    firstName: "Jaylen",
    lastName: "Brown",
    fullName: "Jaylen Brown",
    sport: "basketball",
    league: "NBA",
    team: "Celtics",
    position: "F",
    jerseyNumber: 7,
    yearsActive: "2016-present",
    yearStart: 2016,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'6\"",
    conference: "East",
  },

  // 76ers
  {
    id: "embiid",
    firstName: "Joel",
    lastName: "Embiid",
    fullName: "Joel Embiid",
    sport: "basketball",
    league: "NBA",
    team: "76ers",
    position: "C",
    jerseyNumber: 21,
    yearsActive: "2016-present",
    yearStart: 2016,
    yearEnd: null,
    country: "Cameroon",
    isRetired: false,
    height: "7'0\"",
    conference: "East",
  },
  {
    id: "maxey",
    firstName: "Tyrese",
    lastName: "Maxey",
    fullName: "Tyrese Maxey",
    sport: "basketball",
    league: "NBA",
    team: "76ers",
    position: "G",
    jerseyNumber: 0,
    yearsActive: "2020-present",
    yearStart: 2020,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'2\"",
    conference: "East",
  },

  // Heat
  {
    id: "butler",
    firstName: "Jimmy",
    lastName: "Butler",
    fullName: "Jimmy Butler",
    sport: "basketball",
    league: "NBA",
    team: "Heat",
    position: "F",
    jerseyNumber: 22,
    yearsActive: "2011-present",
    yearStart: 2011,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'7\"",
    conference: "East",
  },
  {
    id: "adebayo",
    firstName: "Bam",
    lastName: "Adebayo",
    fullName: "Bam Adebayo",
    sport: "basketball",
    league: "NBA",
    team: "Heat",
    position: "C",
    jerseyNumber: 13,
    yearsActive: "2017-present",
    yearStart: 2017,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'9\"",
    conference: "East",
  },

  // More current players
  {
    id: "mitchell",
    firstName: "Donovan",
    lastName: "Mitchell",
    fullName: "Donovan Mitchell",
    sport: "basketball",
    league: "NBA",
    team: "Cavaliers",
    position: "G",
    jerseyNumber: 45,
    yearsActive: "2017-present",
    yearStart: 2017,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'1\"",
    conference: "East",
  },
  {
    id: "morant",
    firstName: "Ja",
    lastName: "Morant",
    fullName: "Ja Morant",
    sport: "basketball",
    league: "NBA",
    team: "Grizzlies",
    position: "G",
    jerseyNumber: 12,
    yearsActive: "2019-present",
    yearStart: 2019,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'3\"",
    conference: "West",
  },
  {
    id: "williamson",
    firstName: "Zion",
    lastName: "Williamson",
    fullName: "Zion Williamson",
    sport: "basketball",
    league: "NBA",
    team: "Pelicans",
    position: "F",
    jerseyNumber: 1,
    yearsActive: "2019-present",
    yearStart: 2019,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'6\"",
    conference: "West",
  },
  {
    id: "edwards",
    firstName: "Anthony",
    lastName: "Edwards",
    fullName: "Anthony Edwards",
    sport: "basketball",
    league: "NBA",
    team: "Timberwolves",
    position: "G",
    jerseyNumber: 1,
    yearsActive: "2020-present",
    yearStart: 2020,
    yearEnd: null,
    country: "USA",
    isRetired: false,
    height: "6'4\"",
    conference: "West",
  },
  {
    id: "towns",
    firstName: "Karl-Anthony",
    lastName: "Towns",
    fullName: "Karl-Anthony Towns",
    sport: "basketball",
    league: "NBA",
    team: "Knicks",
    position: "C",
    jerseyNumber: 32,
    yearsActive: "2015-present",
    yearStart: 2015,
    yearEnd: null,
    country: "Dominican Republic",
    isRetired: false,
    height: "6'11\"",
    conference: "East",
  },

  // Retired Legends
  {
    id: "jordan",
    firstName: "Michael",
    lastName: "Jordan",
    fullName: "Michael Jordan",
    sport: "basketball",
    league: "NBA",
    team: "Bulls",
    position: "G",
    jerseyNumber: 23,
    yearsActive: "1984-2003",
    yearStart: 1984,
    yearEnd: 2003,
    country: "USA",
    isRetired: true,
    height: "6'6\"",
    conference: "East",
  },
  {
    id: "kobe",
    firstName: "Kobe",
    lastName: "Bryant",
    fullName: "Kobe Bryant",
    sport: "basketball",
    league: "NBA",
    team: "Lakers",
    position: "G",
    jerseyNumber: 24,
    yearsActive: "1996-2016",
    yearStart: 1996,
    yearEnd: 2016,
    country: "USA",
    isRetired: true,
    height: "6'6\"",
    conference: "West",
  },
  {
    id: "shaq",
    firstName: "Shaquille",
    lastName: "O'Neal",
    fullName: "Shaquille O'Neal",
    sport: "basketball",
    league: "NBA",
    team: "Lakers",
    position: "C",
    jerseyNumber: 34,
    yearsActive: "1992-2011",
    yearStart: 1992,
    yearEnd: 2011,
    country: "USA",
    isRetired: true,
    height: "7'1\"",
    conference: "West",
  },
  {
    id: "duncan",
    firstName: "Tim",
    lastName: "Duncan",
    fullName: "Tim Duncan",
    sport: "basketball",
    league: "NBA",
    team: "Spurs",
    position: "F",
    jerseyNumber: 21,
    yearsActive: "1997-2016",
    yearStart: 1997,
    yearEnd: 2016,
    country: "USA",
    isRetired: true,
    height: "6'11\"",
    conference: "West",
  },
  {
    id: "magic",
    firstName: "Magic",
    lastName: "Johnson",
    fullName: "Magic Johnson",
    sport: "basketball",
    league: "NBA",
    team: "Lakers",
    position: "G",
    jerseyNumber: 32,
    yearsActive: "1979-1996",
    yearStart: 1979,
    yearEnd: 1996,
    country: "USA",
    isRetired: true,
    height: "6'9\"",
    conference: "West",
  },
  {
    id: "bird",
    firstName: "Larry",
    lastName: "Bird",
    fullName: "Larry Bird",
    sport: "basketball",
    league: "NBA",
    team: "Celtics",
    position: "F",
    jerseyNumber: 33,
    yearsActive: "1979-1992",
    yearStart: 1979,
    yearEnd: 1992,
    country: "USA",
    isRetired: true,
    height: "6'9\"",
    conference: "East",
  },
  {
    id: "kareem",
    firstName: "Kareem",
    lastName: "Abdul-Jabbar",
    fullName: "Kareem Abdul-Jabbar",
    sport: "basketball",
    league: "NBA",
    team: "Lakers",
    position: "C",
    jerseyNumber: 33,
    yearsActive: "1969-1989",
    yearStart: 1969,
    yearEnd: 1989,
    country: "USA",
    isRetired: true,
    height: "7'2\"",
    conference: "West",
  },
  {
    id: "hakeem",
    firstName: "Hakeem",
    lastName: "Olajuwon",
    fullName: "Hakeem Olajuwon",
    sport: "basketball",
    league: "NBA",
    team: "Rockets",
    position: "C",
    jerseyNumber: 34,
    yearsActive: "1984-2002",
    yearStart: 1984,
    yearEnd: 2002,
    country: "Nigeria",
    isRetired: true,
    height: "7'0\"",
    conference: "West",
  },
  {
    id: "dirk",
    firstName: "Dirk",
    lastName: "Nowitzki",
    fullName: "Dirk Nowitzki",
    sport: "basketball",
    league: "NBA",
    team: "Mavericks",
    position: "F",
    jerseyNumber: 41,
    yearsActive: "1998-2019",
    yearStart: 1998,
    yearEnd: 2019,
    country: "Germany",
    isRetired: true,
    height: "7'0\"",
    conference: "West",
  },
  {
    id: "iverson",
    firstName: "Allen",
    lastName: "Iverson",
    fullName: "Allen Iverson",
    sport: "basketball",
    league: "NBA",
    team: "76ers",
    position: "G",
    jerseyNumber: 3,
    yearsActive: "1996-2010",
    yearStart: 1996,
    yearEnd: 2010,
    country: "USA",
    isRetired: true,
    height: "6'0\"",
    conference: "East",
  },
  {
    id: "wade",
    firstName: "Dwyane",
    lastName: "Wade",
    fullName: "Dwyane Wade",
    sport: "basketball",
    league: "NBA",
    team: "Heat",
    position: "G",
    jerseyNumber: 3,
    yearsActive: "2003-2019",
    yearStart: 2003,
    yearEnd: 2019,
    country: "USA",
    isRetired: true,
    height: "6'4\"",
    conference: "East",
  },
  {
    id: "garnett",
    firstName: "Kevin",
    lastName: "Garnett",
    fullName: "Kevin Garnett",
    sport: "basketball",
    league: "NBA",
    team: "Timberwolves",
    position: "F",
    jerseyNumber: 21,
    yearsActive: "1995-2016",
    yearStart: 1995,
    yearEnd: 2016,
    country: "USA",
    isRetired: true,
    height: "6'11\"",
    conference: "West",
  },
  {
    id: "pierce",
    firstName: "Paul",
    lastName: "Pierce",
    fullName: "Paul Pierce",
    sport: "basketball",
    league: "NBA",
    team: "Celtics",
    position: "F",
    jerseyNumber: 34,
    yearsActive: "1998-2017",
    yearStart: 1998,
    yearEnd: 2017,
    country: "USA",
    isRetired: true,
    height: "6'7\"",
    conference: "East",
  },
  {
    id: "nash",
    firstName: "Steve",
    lastName: "Nash",
    fullName: "Steve Nash",
    sport: "basketball",
    league: "NBA",
    team: "Suns",
    position: "G",
    jerseyNumber: 13,
    yearsActive: "1996-2014",
    yearStart: 1996,
    yearEnd: 2014,
    country: "Canada",
    isRetired: true,
    height: "6'3\"",
    conference: "West",
  },
  {
    id: "kidd",
    firstName: "Jason",
    lastName: "Kidd",
    fullName: "Jason Kidd",
    sport: "basketball",
    league: "NBA",
    team: "Nets",
    position: "G",
    jerseyNumber: 5,
    yearsActive: "1994-2013",
    yearStart: 1994,
    yearEnd: 2013,
    country: "USA",
    isRetired: true,
    height: "6'4\"",
    conference: "East",
  },
]

// Soccer players (simplified for now, focusing on NBA)
